import listActions from 'src/modules/eventClass/list/eventClassListActions';
import EventClassService from 'src/modules/eventClass/eventClassService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'EVENTCLASS_DESTROY';

const eventClassDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: eventClassDestroyActions.DESTROY_STARTED,
      });

      await EventClassService.destroyAll([id]);

      dispatch({
        type: eventClassDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.eventClass.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/event-class');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: eventClassDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: eventClassDestroyActions.DESTROY_ALL_STARTED,
      });

      await EventClassService.destroyAll(ids);

      dispatch({
        type: eventClassDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.eventClass.destroyAll.success'),
      );

      getHistory().push('/event-class');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: eventClassDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default eventClassDestroyActions;
